/** Sort direction for the `sort_by` value in API requests. */
export enum SortDirection {
  Ascending = 'asc',
  Descending = 'desc',
}

/** Generic sort by type for the `sort_by` field in API requests. */
export type SortBy<TSortKey extends string> = `${TSortKey}:${SortDirection}`;

// TODO: make SortStatus more type safe. Related task [TEAMS-5447]
/** Generic sort status type for the sortable table. */
export type SortStatus<TSortKey = string | number> = {
  direction: 'asc' | 'desc';
  sortBy: TSortKey;
};
